import { createAsyncThunk } from "@reduxjs/toolkit";
import PostEvidenceAPI from "./postEvidenceAPI";

// CREATE
export const createEvidenceThunk = createAsyncThunk(
  "evidence/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.createEvidence(payload);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// GET single evidence
export const getEvidenceThunk = createAsyncThunk(
  "evidence/getOne",
  async (evidenceId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getEvidence(evidenceId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// LIST
export const listEvidenceThunk = createAsyncThunk(
  "evidence/list",
  async (params, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.listEvidence(params);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// UPDATE
export const updateEvidenceThunk = createAsyncThunk(
  "evidence/update",
  async ({ evidenceId, update }, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.updateEvidence(evidenceId, update);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// DELETE
export const deleteEvidenceThunk = createAsyncThunk(
  "evidence/delete",
  async (evidenceId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.deleteEvidence(evidenceId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// FLAG
export const flagEvidenceThunk = createAsyncThunk(
  "evidence/flag",
  async (payload, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.flagEvidence(payload);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// GET flags
export const getEvidenceFlagsThunk = createAsyncThunk(
  "evidence/getFlags",
  async (evidenceId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getEvidenceFlags(evidenceId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// Resolve flag
export const resolveFlagThunk = createAsyncThunk(
  "evidence/resolveFlag",
  async ({ flagId, is_upheld }, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.resolveFlag(flagId, is_upheld);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// Helpful toggle
export const toggleHelpfulThunk = createAsyncThunk(
  "evidence/toggleHelpful",
  async (evidenceId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.toggleHelpful(evidenceId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const checkHelpfulThunk = createAsyncThunk(
  "evidence/checkHelpful",
  async (evidenceId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.checkHelpful(evidenceId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// Post score
export const getPostScoreThunk = createAsyncThunk(
  "evidence/getPostScore",
  async (postId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getPostScore(postId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// User stats
export const getUserEvidenceStatsThunk = createAsyncThunk(
  "evidence/getUserStats",
  async (userId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getUserEvidenceStats(userId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// Post summary
export const getPostEvidenceSummaryThunk = createAsyncThunk(
  "evidence/getSummary",
  async (postId, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getPostEvidenceSummary(postId);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// ADMIN disputed queue
export const getDisputedEvidenceThunk = createAsyncThunk(
  "evidence/admin/getDisputed",
  async (params, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.getDisputedEvidence(params);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

// ADMIN update status
export const adminUpdateEvidenceStatusThunk = createAsyncThunk(
  "evidence/admin/updateStatus",
  async ({ evidenceId, new_status }, { rejectWithValue }) => {
    try {
      return await PostEvidenceAPI.updateEvidenceStatusAdmin(evidenceId, new_status);
    } catch (err) {
      // Was plain err.message (generic Axios text like "Request failed
      // with status code 400") -- this file's own CRUD layer writes real,
      // specific messages ("At least one source must be provided", "Either
      // post_id or group_post_id must be provided") that never reached the
      // user because of this. Matches the pattern most other thunks in the
      // app already use.
      return rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);
